import { Component, ViewChild } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { takeUntil } from "rxjs/operators";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { RewardPaymentEffectWork } from "../../models/reward-payment-effect-work.model";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";

@Component({
  selector: "reward-payment-effect-work-form",
  templateUrl: "./reward-payment-effect-work-form.component.html",
  styleUrls: ["./reward-payment-effect-work-form.component.scss"],
})
export class RewardPaymentEffectWorkFormComponent extends BaseFormComponent<RewardPaymentEffectWork> {
  public label: string = "اصلاح کارکرد عیدی";
  public dataList: RewardPaymentEffectWork[];
  @ViewChild("grid") public grid: EditableGridComponent;
  gridColumns: form_control[] = [];
  isRefreshingData: boolean = false;
  DefaultValues: Dictionary = [];
  RemainDays: number = 0;
  HasCalculate: boolean = false;
  async ngOnInit() {
    this.areaName = "Payroll";
    this.apiName = "RewardPaymentEffectWork";
    this.dataList = [];
    super.ngOnInit();
    await this.setData();
  }
  setColumnAttribute() {
    this.gridColumns = Object.assign([], this.orignalColumns);
    this.gridColumns.forEach((x) => {
      if (x.name !== "EffectWork" && x.listVisible === true) x.disabled = true;
    });
  }
  onChanged($event) {
    if ($event && $event?.apiName === "RewardPaymentEffectWork/RewardPaymentEffectWorkElement") {
      this.setData();
    }
  }
  async setData() {
    if (this.isRefreshingData === true) return;
    if (!this.formGroup?.get("ElementId")?.value) {
      return;
    }
    let gridFilter: GridFilter[] = [];
    if (this.formGroup?.get("ElementId")?.value)
      gridFilter.push({
        Filed: "ElementId",
        Operator: "eq",
        Type: "F",
        Skip: 0,
        Take: 20,
        Value: this.formGroup?.get("ElementId")?.value,
        Logic: "and",
      });
    gridFilter.push({
      Filed: "IssueYear",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentYear,
      Logic: "and",
    });
    gridFilter.push({
      Filed: "IssueMonth",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentMonth,
      Logic: "and",
    });
    gridFilter.push({ Filed: "RemainDays", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.RemainDays, Logic: "and" });
    gridFilter.push({ Filed: "HasCalculate", Operator: "eq", Type: "F", Skip: 0, Take: 20, Value: this.HasCalculate, Logic: "and" });

    this.isRefreshingData = true;
    await this.httpCommonService
      .create(`${this.apiName}/GetEffectWork`, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          this.HasCalculate = false;
          this.isRefreshingData = false;
          if (data) {
            this.dataList = data as [];
            this.model = this.dataList[0];
            this.setFormGroup(this.model);
            this.formGroup.markAsPristine();
          }
        },
        (error) => {
          this.isRefreshingData = false;
          this.getFailedHelper(error);
        }
      );
  }
  calculate() {
    this.sts.showDialog("بااجراء اين دستور اطلاعات جايگزین خواهد شد آيا ادامه مي دهيد؟", "اصلاح كاركرد عيدي", DialogType.confirm, () =>
      this.calculateEffectWork()
    );
  }
  async calculateEffectWork() {
    this.HasCalculate = true;
    if (this.formGroup?.get("CalculateToEndOfYear")?.value === true) await this.GetRemainDays();
    else await this.setData();
  }
  async GetRemainDays() {
    let gridFilter: GridFilter[] = [];
    gridFilter.push({
      Filed: "ElementId",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.formGroup?.get("ElementId")?.value,
      Logic: "and",
    });
    gridFilter.push({
      Filed: "IssueYear",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentYear,
      Logic: "and",
    });
    gridFilter.push({
      Filed: "IssueMonth",
      Operator: "eq",
      Type: "F",
      Skip: 0,
      Take: 20,
      Value: this.accountService?.authService?.getHrmPayCurentYearMonth()?.CurentMonth,
      Logic: "and",
    });

    await this.httpCommonService
      .create(`${this.apiName}/GetRemainDays`, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        async (data) => {
          this.RemainDays = data;
          await this.setData();
        },
        (error) => {
          this.isRefreshingData = false;
          this.getFailedHelper(error);
        }
      );
  }
  async save() {
    this.selectorService.submitted$.next(this.submitted);
    this.closeModal();
  }
  async _save(event: RewardPaymentEffectWork) {
    try {
      if (!this.isSaving) {
        if (this.isValid()) {
          this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
          this.isSaving = true;
          this.isSaved = false;
          if (event.Id === undefined || event.Id === 0 || Number.isNaN(event.Id) || event.Id === null) {
            await this.httpCommonService
              .create(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          } else {
            await this.httpCommonService
              .update(this.apiName, event)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then(
                (row) => {},
                (error) => this.saveFailedHelper(error)
              );
          }
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }
}
